export default __webpack_public_path__ + "static/media/NotoKufiArabic-Regular.dec88e9b.ttf";